module.exports = __webpack_public_path__ + "static/media/A2888-Tutorial.8fc16e78.pdf";